import {
  DataGrid,
  GridColDef,
  GridFilterModel,
  GridToolbar,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { SystemsType } from "../../views/admin/systems/index";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useEffect, useState } from "react";
import { deleteManyDataById } from "api";

interface Props {
  rows: any[];
  columns: GridColDef[];
  loading: boolean;
  deleteMultiple?: boolean;
  collection?: string;
  reload?: any;
  /** Called with `true` when any search/filter is active, `false` when cleared */
  onFilterActiveChange?: (isActive: boolean) => void;
  hideSearch?: boolean;
  getRowHeight?: (params: any) => number | "auto";
}

const getRowId = (row: any) => row._id;

export default function DataTable(props: Props) {
  const [selectedNotes, setSelectedNotes] = useState<string[]>([]);

  const handleMultiNoteDelete = async () => {
    if (selectedNotes.length >= 0) {
      const response = await deleteManyDataById(
        props.collection,
        selectedNotes
      );
      if (response.success) {
        props.reload();
      } else {
        alert(response.message);
      }
    }
  };

  function CustomToolbar() {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "8px",
        }}
      >
        <GridToolbar
          sx={{
            "& .MuiButtonBase-root": {
              color: "var(--color-brand-500, rgb(66, 42, 251))",
            },
          }}
        />
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {!props.hideSearch && (
            <GridToolbarQuickFilter
              quickFilterParser={(searchInput: string) =>
                searchInput
                  .split(/[\s,]+/)
                  .map((value) => value.trim())
                  .filter((value) => value !== "")
              }
              sx={{
                "& .MuiInputBase-root": {
                  borderRadius: "8px",
                  border: "1px solid var(--color-shadow-secondary, #e2e8f0)",
                  backgroundColor: "var(--color-surface-primary, #f8fafc)",
                  color: "var(--color-text-primary, inherit)",
                  padding: "2px 10px",
                  fontSize: "13px",
                },
                "& .MuiInputBase-root:before, & .MuiInputBase-root:after": {
                  display: "none",
                },
                "& .MuiSvgIcon-root": {
                  color: "var(--color-brand-500, rgb(66, 42, 251))",
                },
              }}
              placeholder="Search..."
              debounceMs={200}
            />
          )}
          {props.deleteMultiple == true && selectedNotes.length >= 2 && (
            <button className="relative block" onClick={handleMultiNoteDelete}>
              <RiDeleteBin6Line className="text-red-600 text-xl hover:text-red-600/80 active:text-red-600/70" />
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        height: "calc(112vh - 270px)",
        width: "100%",
        marginBottom: "30px",
        overflowX: "visible",
        overflowY: "visible",
      }}
    >
      <DataGrid
        sx={{
          padding: 2,
          border: "none",
          color: "var(--color-text-primary, inherit)",
          "& .MuiDataGrid-cell": {
            borderBottom: "1px solid var(--color-surface-secondary, #e2e8f0)",
            color: "var(--color-text-primary, inherit)",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "var(--color-surface-secondary, #f8fafc)",
            borderBottom: "1px solid var(--color-shadow-secondary, #cbd5e0)",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: "bold",
            color: "var(--color-text-primary, inherit)",
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "1px solid var(--color-shadow-secondary, #cbd5e0)",
          },
          "& .MuiTablePagination-root": {
            color: "var(--color-text-secondary, inherit)",
          },
          "& .MuiIconButton-root": {
            color: "var(--color-text-secondary, inherit)",
          },
          "& .MuiCheckbox-root": {
            color: "var(--color-text-secondary, inherit)",
          },
          "& .Mui-checked": {
            color: "var(--color-brand-500, rgb(66, 42, 251)) !important",
          },
        }}
        // rowHeight={30}
        rows={props.rows ? props.rows : []}
        columns={props.columns ? props.columns : []}
        loading={props.loading}
        components={{
          Toolbar: CustomToolbar,
        }}
        componentsProps={{
          toolbar: {
            showQuickFilter: true,
          },
        }}
        checkboxSelection={props.deleteMultiple}
        getRowId={getRowId}
        onRowSelectionModelChange={(newSelection) => {
          setSelectedNotes(newSelection as string[]);
        }}
        rowSelectionModel={selectedNotes}
        onFilterModelChange={(model: GridFilterModel) => {
          if (props.onFilterActiveChange) {
            const hasQuickFilter =
              model.quickFilterValues && model.quickFilterValues.length > 0;
            const hasColumnFilter =
              model.items && model.items.some((item) => item.value !== undefined && item.value !== "");
            props.onFilterActiveChange(!!(hasQuickFilter || hasColumnFilter));
          }
        }}
        getRowHeight={
          props.getRowHeight
            ? props.getRowHeight
            : (params) => {
                const systems = params.model.system_id || "";
                // If systems is longer than 50 characters, increase row height
                // if (systems.length > 4) return 100;
                if (systems.length > 12) return 160;
                if (systems.length > 7) return 100;
                return 52; // default row height
              }
        }
      // initialState={{
      //     pagination: {
      //         paginationModel: { page: 0, pageSize: 5 }
      //     },
      // }}
      // pageSizeOptions={[5, 10]}
      // checkboxSelection
      />
    </div>
  );
}
